@if (offers) {
  <div class="offer-list" [class.tiles]="viewMode === 'tiles'" [class.list]="viewMode === 'list'">
    @for (offer of offers; track offer; let i = $index) {
      @if (activeOfferType === 'ECI' || activeOfferType === 'LCO') {
        <div class="offer-item">
          <ui-new-offer-card-addon
            [offers]="offers"
            [offer]="offer"
            [index]="i"
            [viewMoreToggle]="viewMoreToggle"
            [offerAliasId]="offerAliasId"
            [propertyId]="propertyId"
            [viewMode]="viewMode">
          </ui-new-offer-card-addon>
        </div>
      }

      @if (activeOfferType === 'ANCILLARY') {
        <div class="offer-item">
          <ui-new-offer-card-ancillary
            [offers]="offers"
            [offer]="offer"
            [index]="i"
            [viewMoreToggle]="viewMoreToggle"
            [offerAliasId]="offerAliasId"
            [propertyId]="propertyId"
            [viewMode]="viewMode">
          </ui-new-offer-card-ancillary>
        </div>
      }

      @if (activeOfferType === 'ROOM') {
        <div class="offer-item offer-item-room">
          <ui-new-offer-card
            [offers]="offers"
            [offer]="offer"
            [index]="i"
            [viewMoreToggle]="viewMoreToggle"
            [offerAliasId]="offerAliasId"
            [propertyId]="propertyId"
            [viewMode]="viewMode">
          </ui-new-offer-card>
        </div>
      }
    }
  </div>
}
